/**
 * 제안형 캠페인 수락 시점에 상품이 품절된 경우 BE 가 내려주는 에러 코드. (SID-4502 / QAT-39681)
 * 이 코드를 받으면 일반 토스트가 아니라 "상품 품절로 캠페인 진행이 불가합니다." 안내 다이얼로그를
 * 노출한다. (RecruitApplyValidationDialog 의 SOLD_OUT 케이스, Figma node 2185-107013)
 */
export const ERROR_CODE_SEEDING_PRODUCT_SOLD_OUT = 'SEEDING-001-005';

/**
 * `executeStandardRequest` 가 non-2xx 를 `{ data, status, message }` 평문 객체로 reject 한다
 * (`data` = 응답 body 원본). BE 가 엔드포인트별로 표준 `{ meta: { errorCode, message } }` 와
 * 비표준 `{ code, message }`(SID-4502 수락 품절 응답) 를 혼용하고, responseType:'text' API 는
 * body 가 JSON 문자열로 오므로, 문자열이면 파싱한 뒤 양쪽 형태를 모두 본다.
 */
const parseErrorData = (error: unknown): Record<string, unknown> | undefined => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return undefined;
  let data: unknown = (error as { data?: unknown }).data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return undefined;
    }
  }
  if (typeof data !== 'object' || data === null) return undefined;
  return data as Record<string, unknown>;
};

const readString = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : undefined;

/** 수락 응답이 "수락 시점 상품 품절(SEEDING-001-005)" 인지 판정한다. */
export const isSeedingProductSoldOutError = (error: unknown): boolean => {
  const data = parseErrorData(error);
  if (!data) return false;
  // 비표준 `{ code, message }` (SID-4502) + 표준 `{ meta: { errorCode } }` 양쪽 지원.
  const meta = data.meta as { errorCode?: unknown } | undefined;
  const code = readString(data.code) ?? readString(meta?.errorCode);
  return code === ERROR_CODE_SEEDING_PRODUCT_SOLD_OUT;
};

/** 품절 다이얼로그 본문에 그대로 쓸 BE 응답 message. 없으면 undefined → 호출부 fallback. */
export const readSeedingProductSoldOutMessage = (error: unknown): string | undefined => {
  const data = parseErrorData(error);
  if (!data) return undefined;
  const meta = data.meta as { message?: unknown } | undefined;
  return readString(data.message) ?? readString(meta?.message);
};
